import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AssetImagePreview from './AssetImagePreview';
import AssetPDFPreview from './AssetPDFPreview';
import AssetVideoPreview from './AssetVideoPreview';
import { Icon, Grid } from '@material-ui/core';

import FileViewer from 'react-file-viewer';


const styles = theme => ({
    spacer: {
        marginTop: 25,
        marginBottom: 25
    },
    imgSizer: {
        maxHeight: 220
    }
});

class AssetPreview extends Component {

    render() {
        const { asset_url, asset_format, asset_id, full_page } = this.props
        let imgs = ['png', 'jpg', 'jpeg', 'svg', 'gif']
        let vids = ['mp4', 'flv', 'mkv']

        if (imgs.includes(asset_format)) {
            return (
                <div style={{ height: '200px' }}>
                    <AssetImagePreview asset_url={asset_url} full_page={full_page} />
                </div>
            )
        }

        else if (asset_format === 'pdf') {
            return (
                <div style={{ height: '200px' }}>
                    <AssetPDFPreview asset_url={asset_url} full_page={full_page} />
                </div>
            )
        }
        else if (vids.includes(asset_format)) {
            return (
                <div style={{ height: '200px' }}>
                    <AssetVideoPreview asset_url={asset_url} full_page={full_page} asset_id={asset_id} />
                </div>
            )
        }
        // else if (asset_format === 'xlsx') {
        //     return (
        //         <div style={{ height: '200px' }}>
        //             <AssetExcelPreview asset_url={asset_url} full_page={full_page} asset_id={asset_id} />
        //         </div>
        //     )
        // }
        else if (asset_format === 'pptx') {
            return (
                <div style={{ height: '200px' }}>
                    {/* <AssetPowerpointPreview asset_url={asset_url} full_page={full_page} asset_id={asset_id} /> */}
                    <a href={asset_url} target="_blank"><Icon>cloud_download</Icon>{'click me'}</a>
                </div>
            )
        }
        else if (asset_format === 'docx' || asset_format === 'csv') {
            // The docx package wont work if I try to bring it in from a different component.
            if (full_page) {
                return (
                    <div>
                        <Grid container spacing={24}>
                            <Grid xs={2}>
                            </Grid>
                            <Grid xs={8} style={{ maxHeight: '60vh' }}>
                                <FileViewer
                                    fileType={asset_format}
                                    filePath={asset_url}
                                    errorComponent={<span>error</span>}
                                    onError={(e) => console.log(e)} 
                                />
                            </Grid>
                        </Grid>
                    </div>
                )
            }
            return (
                <div style={{ height: '200px' }}>

                    <FileViewer
                        fileType={asset_format}
                        filePath={asset_url}
                        errorComponent={<span>error</span>}
                        onError={(e) => console.log(e)} 
                    />
                </div>
            )
        }
        else {
            return (<div style={{ height: '200px', marginTop: '25px' }}>Not Supported</div>)
        }
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
    }, dispatch);
}

function mapStateToProps({ auth }) {
    return {
        auth
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(AssetPreview)));


// WEBPACK FOOTER //
// src/main/content/asset/AssetPreview.js